import { render, staticRenderFns } from "./workbench.vue?vue&type=template&id=18b77c98&scoped=true&"
import script from "./workbench.vue?vue&type=script&lang=js&"
export * from "./workbench.vue?vue&type=script&lang=js&"
import style0 from "./workbench.vue?vue&type=style&index=0&id=18b77c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b77c98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b77c98')) {
      api.createRecord('18b77c98', component.options)
    } else {
      api.reload('18b77c98', component.options)
    }
    module.hot.accept("./workbench.vue?vue&type=template&id=18b77c98&scoped=true&", function () {
      api.rerender('18b77c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/workbench.vue"
export default component.exports